export default __webpack_public_path__ + "static/media/person-and-musical-note.9f1c41b9.svg";